var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6.28C14.17.3 22 3.17 22 9.53c0 5.85-6.85 9.87-9.21 11.09a1.7 1.7 0 0 1-1.58 0C8.85 19.4 2 15.38 2 9.53 2 3.17 9.83.3 12 6.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart2.532f5cb9ac6d9e35d855ef7fdc9bd88c.svg";
export { ForwardRef as ReactComponent };